import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=1a1376a9&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=js"
export * from "./FeedbackList.vue?vue&type=script&lang=js"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=1a1376a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1376a9",
  null
  
)

export default component.exports